module.exports = __webpack_public_path__ + "img/doble-deluxe-1.d3ddcbe1.jpg";